var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('div',[_vm._v(" Welcome, use left navigation to move around. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }